import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MemesLeaderboardDropDescriptionProps {
  readonly description: string;
}
const MemesLeaderboardDropDescription: React.FC<MemesLeaderboardDropDescriptionProps> = t0 => {
  const $ = _c(2);
  const {
    description
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = <div><p className="tw-mb-0 tw-whitespace-pre-line tw-text-sm tw-leading-relaxed tw-text-iron-500">{description}</p></div>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MemesLeaderboardDropDescription;